export const historyNotesModalName = 'historyNotesModal';
export const loanInfoModalName = 'loanInfoModal';



// WEBPACK FOOTER //
// ./src/utils/constants/ModalNames.js